import { withDevtools, withDevToolsStub } from '@angular-architects/ngrx-toolkit';

import { getIsOta } from './debug.util';

export const withDebugDevTools = getIsOta() ? withDevtools : withDevToolsStub;
